module.exports = __webpack_public_path__ + "static/media/bree-icon.7358e87d.jpg";